import { Component, EventEmitter, OnInit, Output } from '@angular/core';

import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { AgentsService } from 'src/app/core/services/agents.service';
import { AnnuairePosteFilterParams } from '@models/api/requests';
import { ServicesFonctionnelsService } from 'src/app/core/services/services-fonctionnels.service';
import { PostesService } from 'src/app/core/services/postes.service';
import { ReferentielsService } from 'src/app/core/services/referentiels.service';
import { take } from 'rxjs';
import { DirectionService } from 'src/app/core/services/direction.service';

@Component({
    selector: 'app-consultation-annuaires-filter',
    imports: [
    MatIconModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatSelectModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatInputModule
],
    templateUrl: './consultation-annuaires-filter.component.html',
    styleUrls: ['./consultation-annuaires-filter.component.scss']
})
export class ConsultationAnnuairesFilterComponent implements OnInit {
  filterForm!: FormGroup;
  @Output() filterApplied = new EventEmitter<AnnuairePosteFilterParams>();

  filteredAgents: any[] = [];
  agentsList: any[] = [];

  filteredServices: any[] = [];
  servicesList: any[] = [];

  filteredDirection: any[] = [];
  directionList: any[] = [];

  filteredPostes: any[] = [];
  postesList: any[] = [];

  filteredAgentsRemplaces: any[] = [];

  categoriePosteList: any[] = [];
  typeContratList: any[] = [];

  constructor(
    private readonly agentsService: AgentsService,
    private readonly servicesFonctionnelsService: ServicesFonctionnelsService,
    private readonly directionService: DirectionService,
    private readonly postesService: PostesService,
    private readonly referentielsService: ReferentielsService,
    private readonly formBuilder: FormBuilder
  ) {}

  ngOnInit() {
    this.filterForm = this.formBuilder.group({
      agent: [''],
      direction: [''],
      service: [''],
      structureHierarchique: [''],
      matriculeAgent: [''],
      intitulePoste: [''],
      numeroPoste: [''],
      posteBudgete: [''],
      vacantPourvu: [''],
      ageAgent: [''],
      fonction: [''],
      tauxEmploi: [''],
      categoriePoste: [''],
      typeCT: [''],
      agentRemplace: [''],
      dateDebutContrat: [''],
      dateFinContrat: [''],
      nombreAgent: ['']
    });

    this.loadAgents();
    this.loadServices();
    this.loadDirections();
    this.loadPostes();
    this.loadCategoriePoste();
    this.loadTypeContrat();
  }

  loadAgents() {
    this.agentsService
      .getAllAgentsDemandes('consultation')
      .pipe(take(1))
      .subscribe({
        next: (data) => {
          if (data && Array.isArray(data)) {
            this.agentsList = data;
            this.filteredAgents = [...this.agentsList];
            this.filteredAgentsRemplaces = [...this.agentsList];
          }
        }
      });
  }

  loadServices() {
    this.servicesFonctionnelsService
      .getAllServicesList()
      .pipe(take(1))
      .subscribe({
        next: (data) => {
          if (data && Array.isArray(data)) {
            this.servicesList = data;
            this.filteredServices = [...this.servicesList];
          }
        }
      });
  }
  loadDirections() {
    this.directionService
      .getAllDirectionsDemandes()
      .pipe(take(1))
      .subscribe({
        next: (data) => {
          if (data && Array.isArray(data)) {
            this.directionList = data;
            this.filteredDirection = [...this.directionList];
          }
        }
      });
  }

  loadPostes() {
    this.postesService
      .getAllPostes()
      .pipe(take(1))
      .subscribe({
        next: (data) => {
          if (data && Array.isArray(data)) {
            this.postesList = data;
            this.filteredPostes = [...this.postesList];
          }
        }
      });
  }

  loadCategoriePoste() {
    this.referentielsService
      .getCategoriePoste()
      .pipe(take(1))
      .subscribe((data: any[]) => {
        if (data) {
          this.categoriePosteList = data.filter((o) => o.libelle && o.libelle.trim() !== '');
        }
      });
  }

  loadTypeContrat() {
    this.referentielsService
      .getTypeContrat()
      .pipe(take(1))
      .subscribe((data: any[]) => {
        if (data) {
          this.typeContratList = data.filter((o) => o.libelle && o.libelle.trim() !== '');
        }
      });
  }

  agentFilter(event: any): void {
    const value = event.target.value;
    if (typeof value !== 'string') {
      this.filteredAgents = [];
      return;
    }
    const filterValue = value.toLowerCase().split(' ').join('');
    this.filteredAgents = this.agentsList.filter((agent: any) =>
      (agent.nom + agent.prenom).toLowerCase().split(' ').join('').includes(filterValue)
    );
  }

  agentRemplaceFilter(event: any): void {
    const value = event.target.value;
    if (typeof value !== 'string') {
      this.filteredAgentsRemplaces = [];
      return;
    }
    const filterValue = value.toLowerCase().split(' ').join('');
    this.filteredAgentsRemplaces = this.agentsList.filter((agent: any) =>
      (agent.nom + agent.prenom).toLowerCase().split(' ').join('').includes(filterValue)
    );
  }

  infoPosteFilter(event: any): void {
    const value = event.target.value;
    if (typeof value !== 'string') {
      this.filteredPostes = [];
      return;
    }
    const filterValue = value.toLowerCase();
    this.filteredPostes = this.postesList.filter((poste: any) => {
      const posteStr = poste.code && poste.libelle ? `${poste.code} - ${poste.libelle}` : '';
      return posteStr.toLowerCase().includes(filterValue);
    });
  }
  numeroPosteFilter(event: any): void {
    const value = event.target.value;
    if (typeof value !== 'string') {
      this.filteredPostes = [];
      return;
    }
    const filterValue = value.toLowerCase();
    this.filteredPostes = this.postesList.filter((poste: any) => {
      const posteStr = poste.code ? `${poste.code}` : '';
      return posteStr.toLowerCase().includes(filterValue);
    });
  }

  serviceFilter(event: any): void {
    const value = event.target.value;
    if (typeof value !== 'string') {
      this.filteredServices = [];
      return;
    }
    const filterValue = value.toLowerCase();
    this.filteredServices = this.servicesList.filter((service: any) => service.libelle.toLowerCase().includes(filterValue));
  }
  directionFilter(event: any): void {
    const value = event.target.value;
    if (typeof value !== 'string') {
      this.filteredDirection = [];
      return;
    }
    const filterValue = value.toLowerCase();
    this.filteredDirection = this.directionList.filter((direction: any) => direction.libelle.toLowerCase().includes(filterValue));
  }

  clearAgentFilter(event: any) {
    event.stopPropagation();
    this.filterForm.get('agent')?.setValue(null);
    this.filteredAgents = [...this.agentsList];
  }

  clearStructureHierarchiqueFilter(event: any) {
    event.stopPropagation();
    this.filterForm.get('structureHierarchique')?.setValue('');
  }

  clearFonctionFilter(event: any) {
    event.stopPropagation();
    this.filterForm.get('fonction')?.setValue('');
  }
  clearAgeAgentnFilter(event: any) {
    event.stopPropagation();
    this.filterForm.get('ageAgent')?.setValue('');
  }

  clearMatriculeFilter(event: any) {
    event.stopPropagation();
    this.filterForm.get('matriculeAgent')?.setValue('');
  }

  clearInfoServiceFilter(event: any) {
    event.stopPropagation();
    this.filterForm.get('service')?.setValue('');
    this.filteredServices = [...this.servicesList];
  }
  clearDirectionFilter(event: any) {
    event.stopPropagation();
    this.filterForm.get('direction')?.setValue('');
    this.filteredDirection = [...this.directionList];
  }

  clearPosteBudgeteFilter(event: any) {
    event.stopPropagation();
    this.filterForm.get('posteBudgete')?.setValue('');
  }
  clearVpFilter(event: any) {
    event.stopPropagation();
    this.filterForm.get('vacantPourvu')?.setValue('');
  }

  clearTypeCTFilter(event: any) {
    event.stopPropagation();
    this.filterForm.get('typeCT')?.setValue('');
  }

  clearCodeEngagementFilter(event: any) {
    event.stopPropagation();
    this.filterForm.get('codeEngagement')?.setValue('');
  }

  clearInfoPosteFilter(event: any) {
    event.stopPropagation();
    this.filterForm.get('intitulePoste')?.setValue('');
    this.filteredPostes = [...this.postesList];
  }
  clearNumPosteFilter(event: any) {
    event.stopPropagation();
    this.filterForm.get('numeroPoste')?.setValue('');
    this.filteredPostes = [...this.postesList];
  }

  clearAgentRemplaceFilter(event: any) {
    event.stopPropagation();
    this.filterForm.get('agentRemplace')?.setValue('');
    this.filteredAgentsRemplaces = [...this.agentsList];
  }

  clearCategoriePosteFilter(event: any) {
    event.stopPropagation();
    this.filterForm.get('categoriePoste')?.setValue('');
  }

  clearNombreAgentFilter(event: any) {
    event.stopPropagation();
    this.filterForm.get('nombreAgent')?.setValue('');
  }

  clearTauxEmploiFilter(event: any) {
    event.stopPropagation();
    this.filterForm.get('tauxEmploi')?.setValue('');
  }

  agentDisplayFn(agent: any): string {
    return agent ? `${agent.nom} ${agent.prenom}` : '';
  }

  agentRemplaceDisplayFn(agent: any): string {
    return agent ? `${agent.nom} ${agent.prenom}` : '';
  }

  infoPosteDisplayFn(poste: any): string {
    return poste ? `${poste.libelle}` : '';
  }
  numeroPosteDisplayFn(poste: any): string {
    return poste ? `${poste.code}` : '';
  }

  serviceDisplayFn(service: any): string {
    return service ? service.libelle : '';
  }
  directionDisplayFn(direction: any): string {
    return direction ? direction.libelle : '';
  }

  categoriePosteDisplayFn(categorie: any): string {
    return categorie ? categorie.code : '';
  }

  typeContratDisplayFn(type: any): string {
    return type ? type.libelle : '';
  }

  resetForm() {
    this.filterForm.reset();
    this.filterApplied.emit(this.filterForm.value);
  }

  applyFilters() {
    this.filterApplied.emit(this.filterForm.value);
  }
}
